import React from 'react';
import {observer} from "mobx-react-lite";
import intl from "react-intl-universal";
import {useRootStore, useDsManager, useAppState} from "@stores/AppStateContext";
import { useCrudServices } from "../../../platform/hooks/useServiceCombinations";

import {ItemModelType} from "../../../stores/WorkspaceStore";
import {TrashMenuConfirmation} from "../ListView/TrashMenuConfirmation";
import { deleteItemForever } from "../../../actions/item/deleteItemForever";
import {updateItemChildIdsRemoveUndoable} from "../../../actions/item/undoable/updateItemChildIdsRemoveUndoable";
import {CrudServices} from "../../../platform/services/types/ServiceDependencies";
import {DataSourceManager} from "@stores/dataSources/DataSourceManager";

export interface ItemTrashMenuConfirmationProps {
    item: ItemModelType;
    parentIdFromTree: string | null | undefined;
    className?: string;
}

export const ItemTrashMenuConfirmation = observer(
    ({item, parentIdFromTree, className}: ItemTrashMenuConfirmationProps) => {
        const appState = useAppState();
        const rootStore = appState.rootStore;
        const crudServices = useCrudServices();
        const dsManager = useDsManager();
        const activeWorkspace = rootStore.view.workspace!;
        return (
            <TrashMenuConfirmation
                className={className}
                onCancel={() => activeWorkspace.setConfirmDeleteOpen(undefined)}
                mainAction={async () => {
                    if (item.trashed) {
                        if (!dsManager) {
                            console.error('Data source manager is not ready for delete action');
                            return;
                        }
                        await deleteItemForever(
                            {
                                ...crudServices,
                                appState,
                            },
                            item.id,
                            rootStore.view.workspace!
                        );
                    } else {
                        const parentId = activeWorkspace.confirmDeleteOpenUnder!.split('/')[0];
                        await updateItemChildIdsRemoveUndoable(
                            crudServices,
                            dsManager!,
                            parentId, item.id, rootStore.view.workspace!);
                    }
                    activeWorkspace.setConfirmDeleteOpen(undefined);
                }}
                mainActionText={intl.get('item-line.delete-forever').d("Delete forever")}
                headerText={
                    item.isCluster
                        ? intl.get('item-line.delete-header-cluster').d("Delete cluster forever?")
                        : intl.get('item-line.delete-header-item').d("Delete page forever?")
                }
            />
        )
    }
);
